import { getCommandRequestData } from '@helpers'

export const getFactDutyFilter = (
  startDate: string,
  endDate: string,
  department: any,
  staffQual: any,
  position: any,
  group: any,
  column: any,
  currentDate: string
): string => {
  const parameters = getCommandRequestData(column.command.parameters, {
    currentDate,
    column,
    startDate,
    endDate,
  })
  const filter = parameters.filter ? [parameters.filter] : []

  //TODO УБРАТЬ ХАРДКОД
  if (column.objectCode === 'roster-duty') {
    if (department) {
      filter.push(`(staff_ref.dep_ref=="${department.id}")`)
    }
    if (staffQual && staffQual.id !== 'ALL') {
      filter.push(`(staff_ref.person_qual_ref=in="${staffQual.id}")`)
    }
    if (position) {
      filter.push(`(staff_ref.pos_ref=="${position.id}")`)
    }
    if (group) {
      filter.push(`(staff_ref.group_import=="${group.id}")`)
    }
    // TODO Убрать хардкод в рамках https://jiradc.utg.group/browse/WF-7663
  } else if (
    column.objectCode === 'roster-staff-plan' ||
    column.objectCode === 'roster-staff-plan-new'
  ) {
    if (department) {
      filter.push(`(dep_ref.dep_id=="${department.id}")`)
    }
    if (staffQual) {
      filter.push(`(person_qual_ref=in="${staffQual.id}")`)
    }
  }

  return filter.join(';')
}
